import { render, staticRenderFns } from "./securityVerification.vue?vue&type=template&id=0be90b66&scoped=true&"
import script from "./securityVerification.vue?vue&type=script&lang=ts&"
export * from "./securityVerification.vue?vue&type=script&lang=ts&"
import style0 from "./securityVerification.vue?vue&type=style&index=0&id=0be90b66&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be90b66",
  null
  
)

export default component.exports